import { httpRequest } from "../../http";
export class CommandDefinitionList {
    async run(organizationId?: number) {
        const base = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/definitions/`
        const url = organizationId ? `${base}?organization=${organizationId}` : base
        try {
            const response = await httpRequest<any>(url, { method: "GET" });
            return response;

        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
}
